<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="400"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        {{ message }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Bus from '@/bus';
export default {
  data: () => ({
    dialog: false,
    message: 'Please stand by'
  }),
  created(){
    Bus.$on('loading', this.loading)
  },
  methods: {
    loading(message = null) {
      this.dialog = !this.dialog;
      this.message = this.dialog && message ? message : 'Please stand by';
    },
  },
};
</script>